import { RHFAutocomplete } from "@components/hook-form";

const rectificationReasonOptions = [
  "quantityCorrection",
  "priceAdjustment",
  "discountApplied",
  "partialCancellation",
  "fullCancellation",
];

export const RectificationReason = ({ translate }) => {
  const formattedOptions = rectificationReasonOptions.map((reason) => ({
    label: translate(`correctiveInvoice_${reason}`) || reason, 
    value: reason, 
  }));

  return (
    <RHFAutocomplete
      name="rectificationReason"
      label={translate("rectificationReason")}
      options={formattedOptions}
      freeSolo
    />
  );
};